module.exports = "<div class=\"filter_duration_view\"><div class=\"title\">{{title}}:</div><div class=\"lpview_duration_input\"></div></div>";